module.exports = __webpack_public_path__ + "img/energy.91ed8bc6.svg";